import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation } from 'react-i18next';
import { parentalConsentCopy } from '@/Pages/ParentalConsent/copy';
import { COMMON_NAMESPACE } from '@/i18n';
import '@/Pages/ParentalConsent/ParentalConsentPage.sass';

type ParentalConsentCtaProps = {
  disabled: boolean;
  isSubmitting: boolean;
  onSubmit: () => void;
  onBack: () => void;
};

export function ParentalConsentCta({
  disabled,
  isSubmitting,
  onSubmit,
  onBack,
}: ParentalConsentCtaProps): JSX.Element {
  const { t } = useTranslation(COMMON_NAMESPACE);

  return (
    <Box className="parental-consent-cta" data-testid="parental-consent-cta">
      <Button
        type="button"
        variant="contained"
        color="primary"
        fullWidth
        disabled={disabled || isSubmitting}
        aria-busy={isSubmitting}
        loading={isSubmitting}
        className="parental-consent-cta__button"
        loadingIndicator={
          <CircularProgress
            size={22}
            aria-label={t('loading')}
            className="parental-consent-cta__loader"
          />
        }
        loadingPosition="end"
        onClick={onSubmit}
        endIcon={
          isSubmitting ? undefined : (
            <ArrowForwardRoundedIcon aria-hidden fontSize="small" />
          )
        }
        data-testid="parental-consent-submit-button"
      >
        {isSubmitting ? parentalConsentCopy.ctaLoading : parentalConsentCopy.cta}
      </Button>

      <Button
        type="button"
        variant="text"
        color="primary"
        className="parental-consent-cta__back"
        onClick={onBack}
        data-testid="parental-consent-back-button"
      >
        {parentalConsentCopy.backLink}
      </Button>
    </Box>
  );
}
